import React, { useState } from 'react';
import { Check, X, Sparkles, Shield, Users, User, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);
  return <div className="flex flex-col min-h-screen w-full font-inter bg-white" data-id="element-4594">
      <TopBar data-id="element-4595" />
      <Header data-id="element-4596" />

      {/* Hero Section */}
      <section className="w-full bg-white py-16 md:py-24 border-b border-gray-200" data-id="element-4597">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4598">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#111111] mb-6 leading-tight" data-id="element-4599">
            Honest pricing. No games.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-4600">
            No upsells. No confusing tiers. No fear-mongering. One price gets
            your whole family guided, protected, and on track.
          </p>

          {/* Monthly/Annual Toggle */}
          <div className="mt-12 flex items-center justify-center space-x-4" data-id="element-4601">
            <span className={`text-lg font-medium ${!isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4602">
              Monthly
            </span>
            <button onClick={() => setIsAnnual(!isAnnual)} className="relative w-16 h-8 bg-#[631bb7] rounded-full p-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-#[631bb7]" data-id="element-4603">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isAnnual ? 'translate-x-8' : 'translate-x-0'}`} data-id="element-4604" />
            </button>
            <span className={`text-lg font-medium ${isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4605">
              Annual <span className="text-[#631bb7] text-sm" data-id="element-4606">(Save 20%)</span>
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-4607">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4608">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-4609">
            {/* Foundation (Free) */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full" data-id="element-4610">
              <div className="mb-6" data-id="element-4611">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4612">
                  Foundation
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4613">
                  Essential basics for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4614">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4615">
                  $0
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4616">/forever</span>
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-gray-100 text-[#111111] font-bold rounded-lg hover:bg-gray-200 transition-colors mb-8" data-id="element-4617">
                Start for Free
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4618">
                <li className="flex items-start" data-id="element-4619">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4620" />
                  <span className="text-gray-700 text-sm" data-id="element-4621">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4622">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4623" />
                  <span className="text-gray-700 text-sm" data-id="element-4624">
                    See where you stand with a free safety checkup
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4625">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4626" />
                  <span className="text-gray-700 text-sm" data-id="element-4627">
                    Access your first critical walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4628">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4629" />
                  <span className="text-gray-700 text-sm" data-id="element-4630">
                    No credit card required — ever
                  </span>
                </li>
              </ul>
            </div>

            {/* Individual */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full relative" data-id="element-4631">
              <div className="mb-6" data-id="element-4632">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4633">
                  Individual
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4634">
                  Full access for one person
                </p>
              </div>
              <div className="mb-8" data-id="element-4635">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4636">
                  {isAnnual ? '$79' : '$7.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4637">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4638">
                    Save $16/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#1a0647] text-white font-bold rounded-lg hover:bg-[#2d0b75] transition-colors mb-8" data-id="element-4639">
                Choose Individual
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4640">
                <li className="flex items-start" data-id="element-4641">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4642" />
                  <span className="text-gray-700 text-sm" data-id="element-4643">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4644">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4645" />
                  <span className="text-gray-700 text-sm" data-id="element-4646">
                    Everything in Foundation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4647">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4648" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4649">
                    Full access to all 39 guided walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4650">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4651" />
                  <span className="text-gray-700 text-sm" data-id="element-4652">
                    Ongoing check-ins and reminders to keep habits on track
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4653">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4654" />
                  <span className="text-gray-700 text-sm" data-id="element-4655">
                    Personalized action queue — always know what to do next
                  </span>
                </li>
              </ul>
            </div>

            {/* Family (Best Value) */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] shadow-xl flex flex-col h-full relative transform md:-translate-y-4" data-id="element-4656">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-4657">
                Best Value
              </div>
              <div className="mb-6 mt-2" data-id="element-4658">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4659">Family</h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4660">
                  Complete protection for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4661">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4662">
                  {isAnnual ? '$199' : '$19.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4663">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4664">
                    Save $40/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#631bb7] text-white font-bold rounded-lg hover:bg-[#521099] transition-colors mb-8 shadow-md" data-id="element-4665">
                Choose Family
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4666">
                <li className="flex items-start" data-id="element-4667">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4668" />
                  <span className="text-gray-700 text-sm font-bold" data-id="element-4669">
                    Up to 6 people
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4670">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4671" />
                  <span className="text-gray-700 text-sm" data-id="element-4672">
                    Everything in Individual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4673">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4674" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4675">
                    One dashboard to coordinate safety across your whole
                    household
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4676">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4677" />
                  <span className="text-gray-700 text-sm" data-id="element-4678">
                    Each person gets their own guided path
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4679">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4680" />
                  <span className="text-gray-700 text-sm" data-id="element-4681">
                    You can see where everyone stands — and help where needed
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4682">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4683" />
                  <span className="text-gray-700 text-sm" data-id="element-4684">
                    No one falls through the cracks
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lifetime Offer Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24 relative overflow-hidden" data-id="element-4685">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-4686">
          <div className="absolute top-10 left-10 w-64 h-64 bg-[#8041bf] rounded-full filter blur-3xl" data-id="element-4687"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00f4f8] rounded-full filter blur-3xl" data-id="element-4688"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-4689">
          <div className="text-center mb-12" data-id="element-4690">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4691">
              For our first 1,000 families: lifetime access at a founder's
              price.
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-4692">
              One payment. All future updates included. When we add new
              walkthroughs, new check-ins, and new protections — you get them
              automatically. This pricing goes away at 1,000 members.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-4693">
            {/* Lifetime Individual */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-8 border border-white border-opacity-20 hover:bg-opacity-15 transition-all" data-id="element-4694">
              <div className="flex items-center justify-between mb-6" data-id="element-4695">
                <h3 className="text-2xl font-bold text-white" data-id="element-4696">
                  Lifetime Individual
                </h3>
                <User className="text-[#00f4f8] w-8 h-8" data-id="element-4697" />
              </div>
              <div className="mb-6" data-id="element-4698">
                <span className="text-5xl font-extrabold text-white" data-id="element-4699">$199</span>
                <p className="text-[#00f4f8] font-medium mt-2" data-id="element-4700">
                  One-Time Payment
                </p>
              </div>
              <p className="text-gray-300 mb-8" data-id="element-4701">
                Includes all future updates to the Individual Plan.
              </p>
              <button className="w-full py-4 px-6 bg-white text-[#1a0647] font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-4702">
                Get Lifetime Individual
              </button>
            </div>

            {/* Lifetime Family */}
            <div className="bg-gradient-to-br from-[#631bb7] to-[#521099] rounded-2xl p-8 border border-white border-opacity-20 shadow-2xl transform md:scale-105" data-id="element-4703">
              <div className="flex items-center justify-between mb-6" data-id="element-4704">
                <h3 className="text-2xl font-bold text-white" data-id="element-4705">
                  Lifetime Family
                </h3>
                <Users className="text-white w-8 h-8" data-id="element-4706" />
              </div>
              <div className="mb-6" data-id="element-4707">
                <span className="text-5xl font-extrabold text-white" data-id="element-4708">$599</span>
                <p className="text-white text-opacity-90 font-medium mt-2" data-id="element-4709">
                  One-Time Payment
                </p>
              </div>
              <p className="text-white text-opacity-80 mb-8" data-id="element-4710">
                Includes all future updates to the Family Plan for up to 6
                members.
              </p>
              <button className="w-full py-4 px-6 bg-[#00f4f8] text-[#1a0647] font-bold rounded-lg hover:bg-[#00e0e4] transition-colors shadow-lg" data-id="element-4711">
                Get Lifetime Family
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4712">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4713">
          <div className="text-center mb-12" data-id="element-4714">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-4715">
              Why Overpay for Anxiety When You Can Invest in Capability?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-4716">
            <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-4717">
              <thead data-id="element-4718">
                <tr data-id="element-4719">
                  <th className="text-left py-4 px-6 font-bold text-gray-500 uppercase text-sm tracking-wider border-b-2 border-gray-100" data-id="element-4720"></th>
                  <th className="text-left py-4 px-6 border-b-2 border-[#631bb7]" data-id="element-4721">
                    <div className="text-xl font-bold text-[#631bb7]" data-id="element-4722">
                      Caveo
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4723">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4724">
                      Norton 360 / Aura
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4725">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4726">
                      Geek Squad
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-4727">
                {[{
                label: 'Philosophy',
                caveo: 'Gets the important things done — and keeps them done',
                competitor1: 'Sells reactive alerts & fear',
                competitor2: 'Profits from your tech breaking'
              }, {
                label: 'Cost',
                caveo: 'Starts at $7.99/mo',
                competitor1: '$12 - $35/mo',
                competitor2: '$99+ per incident'
              }, {
                label: 'Experience',
                caveo: 'Step-by-step walkthroughs anyone can follow',
                competitor1: 'Confusing technical jargon',
                competitor2: 'In-person visit required'
              }, {
                label: 'Incentive',
                caveo: 'We win when you feel confident',
                competitor1: 'They win when you stay anxious',
                competitor2: 'They win when you have problems'
              }, {
                label: 'Outcome',
                caveo: "A family that's actually protected — not just subscribed to something",
                competitor1: 'Dependency & Confusion',
                competitor2: 'A temporary fix'
              }].map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-4728">
                    <td className="py-6 px-6 font-bold text-[#111111]" data-id="element-4729">
                      {row.label}
                    </td>
                    <td className="py-6 px-6 font-medium text-[#631bb7] bg-[#631bb7] bg-opacity-5" data-id="element-4730">
                      {row.caveo}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4731">
                      {row.competitor1}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4732">
                      {row.competitor2}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-4733">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-4734">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-4735">
            Your Questions, Answered.
          </h2>
          <div className="space-y-6" data-id="element-4736">
            {[{
            q: 'Can I cancel my subscription at any time?',
            a: 'Yes. You can cancel your monthly or annual plan at any time from your account settings. No questions asked. Your plan will remain active until the end of the current billing period.'
          }, {
            q: 'What happens when you add new modules or features?',
            a: "All new modules and feature updates are included in the Individual, Family, and Lifetime plans at no extra cost. Our platform is constantly evolving to meet new threats, and you'll always have the latest protection."
          }, {
            q: 'How does the Family Plan work for different family members?',
            a: "The Family Plan gives you a central dashboard to invite up to 5 other family members. You can use our role-based views to see different information; for example, an adult child can see their parent's progress and help them with tasks, while the parent sees a simplified view focused on their own learning."
          }, {
            q: 'Is the Free (Foundation) plan free forever?',
            a: "Yes. The Foundation plan is free forever. It's a great way to get started with our basic security assessment and introductory modules to see how Caveo works."
          }, {
            q: 'What if I’m not satisfied?',
            a: "We offer a 30-day money-back guarantee on all paid plans, including lifetime memberships. If you're not happy for any reason, just let us know within 30 days of your purchase for a full refund."
          }].map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-4737">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4738">
                  {faq.q}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4739">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4740">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4741">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-4742">
            Start free. See what your family hasn't done yet. Upgrade whenever
            you're ready.
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-4743">
            No email required. No credit card. Just a clear picture of where you
            stand — in 3 minutes.
          </p>
          <Link to="/onboarding" className="inline-block bg-[#631bb7] text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#521099] transition-all shadow-lg transform hover:-translate-y-1" data-id="element-4744">
            Get Started for Free
          </Link>
        </div>
      </section>

      <Footer data-id="element-4745" />
    </div>;
}